import { combineReducers, configureStore } from '@reduxjs/toolkit'
import packagingSlice from './packagingSlice'
import componentTaxonomySlice from './componentTaxonomySlice'
import transportSlice from './transportSlice'
import resourcesSlice from './resourcesSlice'
import auditSlice from './auditSlice'
import salesSlice from './salesSlice'
import storageSlice from './storageSlice'
import companiesSlice from './companiesSlice'
import processSlice from './processSlice'
import processedIngredientSlice from './processedIngredient'
import specialIngredientSlice from './specialIngredientSlice'
import produceSlice from './produceSlice'
import productSlice from './productSlice'
import factorSlice from './factorSlice'
import genericSlice from './genericSlice'
import correlationIdSlice from './correlationIdSlice'
import materialTaxonomySlice from './materialTaxonomySlice'
import packagingProcessSlice from './packagingProcessSlice'
import materialEmissionFactorSlice from './materialEmissionFactorSlice'
import endOfLifeSlice from './endOfLifeSlice'

const rootReducer = combineReducers({
  componentTaxonomySlice,
  packagingSlice,
  transportSlice,
  resourcesSlice,
  storageSlice,
  salesSlice,
  processSlice,
  auditSlice,
  companiesSlice,
  processedIngredientSlice,
  specialIngredientSlice,
  produceSlice,
  productSlice,
  factorSlice,
  correlationId: correlationIdSlice,
  genericSlice,
  materialTaxonomySlice,
  packagingProcessSlice,
  materialEmissionFactorSlice,
  endOfLifeSlice,
})

const setupStore = () => {
  return configureStore({
    reducer: rootReducer,
  })
}

export type RootState = ReturnType<typeof rootReducer>
export type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = AppStore['dispatch']

export default setupStore
